import { ProfileService } from 'client/services';
import { HOME_PAGE } from 'client/utils/routes/routeConstants';

const loader = async ({ params }) => {
    try {
        await ProfileService.patchAcceptUserReaffirmation(params.reaffirmationId);
        return {
            reaffirmationState: {
                code: 200,
                message: 'success',
                redirect: HOME_PAGE
            }
        };
    } catch (e) {
        if (e.code !== 403) {
            throw e;
        }
        return {
            reaffirmationState: {
                code: e.code,
                message: e.message,
                redirect: HOME_PAGE
            }
        };
    }
};

export default loader;
